{{ translation.outlookAddin.cannotFetchError | transloco }}
<span class="hint">{{ translation.outlookAddin.cannotFetchErrorHint | transloco }}</span>
